<div class="modal-content">
  <div class="modal-header">
    <h6 class="modal-title fw-bold">Capping Rule</h6>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
  </div>

  <form [formGroup]="form" (ngSubmit)="submit()">
    <div class="modal-body">
      <div class="mb-3">
        <label for="cappingRuleTitle" class="form-label small fw-bold">Rule Title</label>
        <input formControlName="name" type="text" class="form-control" id="cappingRuleTitle" placeholder="Enter rule title">
      </div>

      <div class="mb-3">
        <label for="cappingSubID" class="form-label small fw-bold">SubID</label>
        <input formControlName="subid" type="text" class="form-control" id="cappingSubID" placeholder="Enter SubID or ALL">
      </div>

      <div class="mb-3">
        <label for="cappingOffer" class="form-label small fw-bold">Select Offer</label>
        <select formControlName="offerId" class="form-select" id="cappingOffer">
          @for (offer of offers; track offer) {
            <option [value]="offer.id">{{ offer }}</option>
          }
        </select>
      </div>

      <div class="row">
        <div class="col-6 mb-3">
          <label for="cappingNumber" class="form-label small fw-bold">Capping Number</label>
          <input formControlName="capping" type="number" class="form-control" id="cappingNumber" placeholder="Enter capping limit">
        </div>
        <div class="col-6 mb-3">
          <label for="cappingPeriodicity" class="form-label small fw-bold">Periodicity</label>
          <select formControlName="periodicity" class="form-select" id="cappingPeriodicity">
            <option value="daily">Daily</option>
            <option value="weekly">Weekly</option>
            <option value="semimonthly">Semimonthly</option>
            <option value="monthly">Monthly</option>
            <option value="bimonthly">Bimonthly</option>
            <option value="quarterly">Quarterly</option>
            <option value="half_yearly">Half-yearly</option>
            <option value="annually">Annually</option>
          </select>
        </div>
      </div>

      <div class="mb-3">
        <label class="form-label small fw-bold">If Capping Exceeded</label>
        <div>
          <div class="form-check">
            <input formControlName="blockTraffic" class="form-check-input" type="radio" id="blockTraffic" [value]="true">
            <label class="form-check-label small fw-bold" for="blockTraffic">Block traffic</label>
          </div>
          <div class="form-check">
            <input formControlName="blockTraffic" class="form-check-input" type="radio" id="dontBlockTraffic" [value]="false">
            <label class="form-check-label small fw-bold" for="dontBlockTraffic">Don't block traffic</label>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer bg-tertiary">
      <button type="button" class="btn btn-outline-primary fw-bold" data-bs-dismiss="modal">Cancel</button>

      <button [disabled]="form.invalid" type="submit" class="btn btn-primary fw-bold">
        {{ cappingRule ? 'Update' : 'Create' }}
      </button>
    </div>
  </form>
</div>
